import api from './api';
import { startAmazonLogin } from './lwaClient';
import type { AuthResponse, User, ApiResponse } from '../types';

export const authService = {
  register: async (email: string, password: string, firstName?: string, lastName?: string): Promise<AuthResponse> => {
    const { data } = await api.post<ApiResponse<AuthResponse>>('/auth/register', { email, password, firstName, lastName });
    return data.data!;
  },

  login: async (email: string, password: string): Promise<AuthResponse> => {
    const { data } = await api.post<ApiResponse<AuthResponse>>('/auth/login', { email, password });
    return data.data!;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
  },

  getMe: async (): Promise<User> => {
    const { data } = await api.get<ApiResponse<User>>('/auth/me');
    return data.data!;
  },

  updateProfile: async (fields: Partial<Pick<User, 'firstName' | 'lastName'>>): Promise<User> => {
    const { data } = await api.patch<ApiResponse<User>>('/auth/me', fields);
    return data.data!;
  },

  /** Browser-only Login with Amazon; static hosting has no server-side OAuth endpoint. */
  loginWithAmazon: (): void => {
    void startAmazonLogin();
  },
};
